module.exports = __webpack_public_path__ + "static/media/8OLA12.3932d7ca.jpg";